( function ( $ ) {
  	var Cookies2 = Cookies.noConflict();
  
  	// if cookie warning not accepted yet
    if (Cookies2.get('cookieaccepted') === undefined) {
      $("#cookie").show();
    } else if (Cookies2.get('wh') !== undefined && Cookies2.get('wholesale-warning') === undefined) {
      $("#wholesale-warning").show();
    } else if (Cookies2.get('retail-announcement') === undefined) {
    	$("#announcement").show();
    }

    $("#acceptcookies").on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      $("#cookie").hide();
      Cookies2.set('cookieaccepted', 'yes', { expires: 365, secure: true, domain: '.bodyjewellery.co.uk', path: "/" });
    });

    $("#accept-wholesale-warning").on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      $("#wholesale-warning").hide();
      Cookies2.set('wholesale-warning', 'yes', { expires: 3, secure: true, domain: '.bodyjewellery.co.uk', path: "/" });
    });
  
  $(".announcement-bar__close").on('click', function(e){
    if ($(this).hasClass("weekly")) {
    	Cookies2.set('retail-announcement', 'yes', { expires: 7, secure: true, domain: '.bodyjewellery.co.uk', path: "/" });
    }
  });

} ) ( jQuery );